import { render, staticRenderFns } from "./AccuBalanceDialog.vue?vue&type=template&id=e970a5ac&scoped=true"
import script from "./AccuBalanceDialog.vue?vue&type=script&lang=js"
export * from "./AccuBalanceDialog.vue?vue&type=script&lang=js"
import style0 from "./AccuBalanceDialog.vue?vue&type=style&index=0&id=e970a5ac&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e970a5ac",
  null
  
)

export default component.exports